module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-cal__event-container",
    on: {
      "pointerenter": _vm.onMouseEnterDay,
      "pointerleave": _vm.onMouseLeaveDay
    }
  }, [(_vm.isDraggingEvent) ? _c('div', {
    staticClass: "day-cal__event-container__events",
    class: [{
      'day-cal__event-container__events--active--resizing': _vm.isResizingEvent
    }, {
      'day-cal__event-container__events--active': _vm.dragLesson
    }]
  }, [(_vm.dragLesson && _vm.isActiveDay) ? _c('div', {
    staticClass: "day-cal__event day-cal__event--dragged",
    class: {
      'day-cal__event--is-small': _vm.dragEventHeight < 20
    },
    style: ({
      'borderColor': _vm.dragLesson.obj.color,
      'height': _vm.dragEventHeight + 'px',
      'top': (_vm.dragEventY - 1) + 'px',
      'left': 0,
      'width': '100%',
      'zIndex': 100
    }),
    attrs: {
      "data-cols": "1"
    }
  }, [_c('div', {
    staticClass: "day-cal__event__content"
  }, [_c('div', {
    staticClass: "day-cal__event__content__header"
  }, [_c('div', {
    staticClass: "d-cal__event-title"
  }, [_vm._v(_vm._s(_vm.dragLesson.obj.title))]), _vm._v(" "), _c('div', {
    staticClass: "d-cal__event-time"
  }, [_c('span', {
    staticClass: "d-cal__event-time__start"
  }, [_vm._v(_vm._s(_vm.dragEventStartTime) + " - " + _vm._s(_vm.dragEventEndTime))]), _vm._v(" "), (_vm.dragLesson.obj.has_notes) ? _c('span', {
    staticClass: "d-cal__event-meta icon-file-text2"
  }) : _vm._e(), _vm._v(" "), (_vm.dragLesson.obj.has_substitute) ? _c('span', {
    staticClass: "d-cal__event-meta icon-users3"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dragLesson.obj.teacher),
      expression: "dragLesson.obj.teacher"
    }],
    staticClass: "day-cal__event__calendar"
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.teacher) + "\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dragLesson.obj.group),
      expression: "dragLesson.obj.group"
    }],
    staticClass: "day-cal__event__calendar"
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.group) + "\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dragLesson.obj.room),
      expression: "dragLesson.obj.room"
    }],
    staticClass: "day-cal__event__calendar"
  }, [_c('span', {
    staticClass: "icon-location"
  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.room) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event__bg",
    staticStyle: {
      "opacity": "1"
    },
    style: ({
      backgroundColor: _vm.dragLesson.obj.color
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event__sider",
    style: ({
      backgroundColor: _vm.dragLesson.obj.color
    })
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event-container__events",
    class: {
      'day-cal__event-container__events--highlighted': _vm.isCopyCalendarModalOpen
    }
  }, _vm._l((_vm.correctEvents), function(event) {
    return _c('div', {
      key: event.obj.event_key,
      staticClass: "day-cal__event",
      class: [{
        'day-cal__event--is-away': event.obj.away
      }, {
        'day-cal__event--is-canceled': event.obj.canceled
      }, {
        'day-cal__event--has-warning': event.obj.collision
      }, {
        'day-cal__event--is-other-calendar': event.obj.v_other_calendar
      }, {
        'day-cal__event--is-locked': _vm.isLocked
      }, {
        'day-cal__event--is-small': event.height < 20
      }, {
        'day-cal__event--other-school': event.obj.v_other_school
      }, {
        'day-cal__event--editable': event.obj.v_is_editable
      }, {
        'day-cal__event--hide': _vm.dragLesson && _vm.dragLesson.obj.event_id === event.obj.event_id && _vm.isDraggingEvent
      }, {
        'fc-bgevent__presence': event.obj.event_type === 'presence'
      }, {
        'day-cal__event--clickable': _vm.isEventsClickable
      }, {
        'day-cal__event--availability': event.obj.rendering
      }],
      style: ({
        'borderColor': event.obj.color,
        'height': event.height + 'px',
        'top': (event.top - 1) + 'px',
        'left': event.left + '%',
        'width': event.width + '%'
      }),
      attrs: {
        "data-cols": event.cols ? event.cols : 1,
        "data-subject-type": event.obj.event_type
      },
      on: {
        "click": function($event) {
          return _vm.onNativeEventClick(event, $event)
        },
        "pointerdown": function($event) {
          $event.preventDefault();
          return _vm.onMouseDown(event, $event)
        }
      }
    }, [(!event.obj.v_other_school && event.obj.event_type !== 'presence') ? _c('div', {
      staticClass: "day-cal__event__content",
      class: {
        'day-cal__event__content--loading': event.obj.v_is_loading
      },
      style: ({
        'borderColor': event.obj.color
      })
    }, [_c('div', {
      staticClass: "day-cal__event__content__header"
    }, [_c('div', {
      staticClass: "d-cal__event-title"
    }, [(event.obj.v_other_calendar) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation: 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
      }],
      staticClass: "d-cal__event__other-calendar js-no-click",
      attrs: {
        "content": _vm.customTooltip(event.obj)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToCalendar(event.obj.calendar_id, $event)
        }
      }
    }, [_c('svg', {
      staticClass: "js-no-click tw-icon w-6 h-6",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": event.obj.color
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      }
    })])]) : _vm._e(), _vm._v(" "), (event.obj.away) ? _c('span', {
      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(event.obj.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "d-cal__event-time"
    }, [_c('span', {
      staticClass: "d-cal__event-time__start"
    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))]), _vm._v(" "), (event.obj.has_notes) ? _c('span', {
      staticClass: "d-cal__event-meta icon-file-text2"
    }) : _vm._e(), _vm._v(" "), (event.obj.has_substitute) ? _c('span', {
      staticClass: "d-cal__event-meta icon-users3"
    }) : _vm._e(), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
      class: {
        'd-cal__event-meta__fixed--canceled': event.obj.canceled
      }
    }, [(event.obj.canceled) ? _c('span', {
      staticClass: "icon-notification22"
    }) : _c('svg', {
      staticClass: "tw-icon tw-icon--warning",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-users"
    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.teacher),
        expression: "event.obj.teacher"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n          " + _vm._s(event.obj.teacher) + "\n        ")]), _vm._v(" "), (!_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-users"
    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.room),
        expression: "event.obj.room"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-location"
    }), _vm._v("\n          " + _vm._s(event.obj.room) + "\n        ")])]) : _vm._e(), _vm._v(" "), (event.obj.v_other_school) ? _c('div', {
      staticClass: "day-cal__event__content"
    }, [_c('div', {
      staticClass: "day-cal__event__content__header"
    }, [_c('div', {
      staticClass: "d-cal__event-title"
    }, [_vm._v(_vm._s(_vm.i18n['other_school']))]), _vm._v(" "), _c('div', {
      staticClass: "d-cal__event-time"
    }, [_c('span', {
      staticClass: "d-cal__event-time__start"
    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))])])])]) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked && !event.obj.v_is_loading) ? _c('div', {
      staticClass: "d-event__side__resizer"
    }) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked) ? _c('div', {
      staticClass: "d-event__resizer"
    }) : _vm._e(), _vm._v(" "), (event.obj.event_type !== 'presence') ? _c('div', {
      staticClass: "day-cal__event__bg",
      style: ({
        backgroundColor: event.obj.color
      })
    }) : _vm._e(), _vm._v(" "), (!event.obj.v_other_calendar && event.obj.event_type !== 'presence') ? _c('div', {
      staticClass: "day-cal__event__sider",
      style: ({
        backgroundColor: event.obj.color
      })
    }) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2036002!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarDayDraggable.vue
// module id = 1801
// module chunks = 1